var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (i18n) {
buf.push("<div id=\"disconnection-warning\"><div class=\"content-fill block-lg\"><div id=\"disconnection-msg\" class=\"content block-h-xl block-v-lg text-center\"><div class=\"block-v-md\"><h2>To complete this lesson, Ed needs to be running in \nthe&nbsp;background.</h2><p class=\"text-md\">To continue, please open Ed and restart the lesson so that \nyour progress can be tracked&nbsp;correctly.</p></div><div class=\"block-v-md\"><a id=\"close-window\" href=\"https://web.edapp.com\" target=\"_self\" class=\"btn btn-solid btn-block\">" + (jade.escape((jade_interp = i18n("buttons.open-ed")) == null ? '' : jade_interp)) + "</a></div></div></div></div>");}.call(this,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}